import { render, staticRenderFns } from "./OverlaySlider.vue?vue&type=template&id=5b747840&"
import script from "./OverlaySlider.vue?vue&type=script&lang=js&"
export * from "./OverlaySlider.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySlider.vue?vue&type=style&index=0&id=5b747840&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports